export default __webpack_public_path__ + "assets/radio.75cfec39.svg";